'use strict';

var Collection = require('base/Colido.Collection');
var CountryModel = require('../models/country');

/**
 * Collection for countries
 *
 * @category   Collection
 * @module     global
 * @copyright  Copyright (c) 2016, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@h-m.io>
 */
var CountriesCollection = Collection.extend({
    model: CountryModel,
    name: 'global:countries',
    sortDefault: 'name.asc',

    initialize: function(models, options) {
        Collection.prototype.initialize.apply(this, arguments);

        // Perform initial sort
        this.sortByFields();
    },
});

module.exports = CountriesCollection;